import React from "react";

import { localizer } from '../../../../Translator'
import allCountries from '../../../../resources/allcountries.json'
import streetTypes from '../../../../resources/streetTypes.json'

import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import Badge from '@material-ui/core/Badge';
import { Alert, AlertTitle } from '@material-ui/lab';
import Paper from "@material-ui/core/Paper";
import { Backdrop, CircularProgress } from "@material-ui/core"

import PostalAddressLayout from "../../../postal-address/PostalAddressLayout.js"

import { TextFieldStyled, AutocompleteStyled } from "../../../common/InputStyled"
import { BoxSelector } from "../../../common/BoxSelector"
import { MultiShipmentLayout } from "../../../common/multishipment/MultiShipmentLayout"
import TooltipStyled from "../../../common/TooltipStyled"

import { SnackbarCustom } from "../../../Utilities/SnackbarCustom"
import Validators from "../../../Utilities/Validators.js";

import OutboxCli from "../../../../sdk/OutboxCli"

import { AddressFormatsModal } from "../../../common/ocr/AddressFormatsModal";

export class AddressSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      address: {
        who: "",
        contact: "",
        phone: "",
        identityCard: "",

        countryIso: "es",
        locality: "",
        postalCode: "",

        streetType: "",
        streetName: "",
        streetNumber: "",
        streetComplements: "",
        envelopeBox: [],
      },
      line1Preview: "",
      line2Preview: "",
      line3Preview: "",
      countrySelected: "",
      streetTypeSelected: "",

      blockAddressForm: false,

      document: null,
      totalPages: 0,
      addressLeft: 45,
      addressTop: 20,
      addressWidth: 42,
      addressHeight: 7,

      draftError: null,
      detectAddressError: null,

      openAddressModal: false,
      openOcrAddressModal: false,
      openMultishipmentModal: false,

      errors: {},
      alertSenderEmpty: null,
      errorSenderEmpty: null,

      isEditing: false,

      isLoading: false
    }
  }

  //Before component is mount, the address preview, country and street type must be inizializated
  componentDidMount() {
    const { address } = this.props

    if (!address) return

    var line1Preview = ""
    var line2Preview = ""
    var line3Preview = ""
    
    line1Preview = (address.who !== null && address.who !== undefined) ? address.who.toString() : ""

    var streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
    var streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
    var streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
    line2Preview = (streetName + " " + streetNumber + " " + streetComplements).trim()

    var postalCode = (address.postalCode !== null && address.postalCode !== undefined) ? address.postalCode.toString() : ""
    var locality = (address.locality !== null && address.locality !== undefined) ? address.locality.toString() : ""
   

    address.streetType = (address.streetType !== null && address.streetType !== undefined && address.streetType !== "") ? address.streetType : ""
    address.countryIso = (address.countryIso !== null && address.countryIso !== undefined && address.countryIso !== "") ? address.countryIso : "es"

    var countrySelected = allCountries.find(country => country.alpha2 === address.countryIso.toLowerCase()) !== undefined
      ? allCountries.find(country => country.alpha2 === address.countryIso.toLowerCase())
      : allCountries.find(country => country.alpha2 === "es")
    
    
    let country = allCountries.find(item => item.alpha2 === countrySelected.alpha2);
    line3Preview = (postalCode !== "" && locality !== "") ? (postalCode + " " + locality).trim() + " " + country.name : ""
    
    var streetTypeSelected = streetTypes.find(streetType => streetType.name === address.streetType) !== undefined
      ? streetTypes.find(streetType => streetType.name === address.streetType)
      : streetTypes.find(streetType => streetType.name === "")
    
    /* if (address.envelopeBox.length !== 3) {
      address.envelopeBox = []
      if (line1Preview) address.envelopeBox.push(line1Preview)
      if (line2Preview) address.envelopeBox.push(line2Preview)
      if (line3Preview) address.envelopeBox.push(line3Preview)
    } else {
      line1Preview = address.envelopeBox[0]
      line2Preview = address.envelopeBox[1]
      line3Preview = address.envelopeBox[2]
    } */

    let left = this.state.addressLeft
    let top = this.state.addressTop
    let width = this.state.addressWidth
    let height = this.state.addressHeight
    
    if (this.props.billable && this.props.billable.destinationAddressBox
      && this.validateBoxSelector(this.props.billable.destinationAddressBox)) {
      left = this.props.billable.destinationAddressBox.left
      top = this.props.billable.destinationAddressBox.top
      width = this.props.billable.destinationAddressBox.width
      height = this.props.billable.destinationAddressBox.height
    }

    let pages = 0;
    if (this.props.draftsSelected) {
      this.props.draftsSelected.forEach(d => {
        pages = pages + d.pages
      })
    }
    let errors = this.state.errors
    if (this.props.ownerAddress === "SENDER" && !Validators.documentIdentification(address.identityCard).isValid) {
      errors.identityCard = localizer.ValidationFieldTextIdCard;
    } else if (this.props.ownerAddress !== "SENDER" && address.identityCard !== null && address.identityCard !== "" && !Validators.documentIdentification(address.identityCard).isValid) {
      errors.identityCard = localizer.ValidationFieldTextIdCard;
    } else {
      errors.identityCard = "";
    }
    this.setState({
      address: address,
      line1Preview: line1Preview,
      line2Preview: line2Preview,
      line3Preview: line3Preview,
      countrySelected: countrySelected,
      streetTypeSelected: streetTypeSelected,
      addressLeft: left,
      addressTop: top,
      addressWidth: width,
      addressHeight: height,
      totalPages: pages,
      errors: errors
    })
  }

  componentDidUpdate(prevProps) {
    const { address } = this.props

    if (!address) return
    if (address === prevProps.address) return

    var line1Preview = ""
    var line2Preview = ""
    var line3Preview = ""

    line1Preview = (address.who !== null && address.who !== undefined) ? address.who.toString() : ""

    //var streetType = (address.streetType !== null && address.streetType !== undefined) ? address.streetType.toString() : ""
    var streetNumber = (address.streetNumber !== null && address.streetNumber !== undefined) ? address.streetNumber.toString() : ""
    var streetName = (address.streetName !== null && address.streetName !== undefined) ? address.streetName.toString() : ""
    var streetComplements = (address.streetComplements !== null && address.streetComplements !== undefined) ? address.streetComplements.toString() : ""
    line2Preview = (streetName + " " + streetNumber + " " + streetComplements).trim()

    var postalCode = (address.postalCode !== null && address.postalCode !== undefined) ? address.postalCode.toString() : ""
    var locality = (address.locality !== null && address.locality !== undefined) ? address.locality.toString() : ""
     

    address.streetType = (address.streetType !== null && address.streetType !== undefined && address.streetType !== "") ? address.streetType : ""
    address.countryIso = (address.countryIso !== null && address.countryIso !== undefined && address.countryIso !== "") ? address.countryIso : "es"

    var countrySelected = allCountries.find(country => country.alpha2.toUpperCase() === address.countryIso.toUpperCase()) !== undefined
      ? allCountries.find(country => country.alpha2.toUpperCase() === address.countryIso.toUpperCase())
      : allCountries.find(country => country.alpha2.toUpperCase() === "ES")
      
    let country = allCountries.find(item => item.alpha2.toUpperCase() === countrySelected.alpha2.toUpperCase());
    line3Preview = (postalCode !== "" && locality !== "") ? (postalCode + " " + locality).trim() + " " + country.name : ""
      
    var streetTypeSelected = streetTypes.find(streetType => streetType.name === address.streetType) !== undefined
      ? streetTypes.find(streetType => streetType.name === address.streetType)
      : streetTypes.find(streetType => streetType.name === "")
      
    /* if (address.envelopeBox.length !== 3) {
      address.envelopeBox = []
      if (line1Preview) address.envelopeBox.push(line1Preview)
      if (line2Preview) address.envelopeBox.push(line2Preview)
      if (line3Preview) address.envelopeBox.push(line3Preview)
    } else {
      line1Preview = address.envelopeBox[0]
      line2Preview = address.envelopeBox[1]
      if (address.envelopeBox[2] !== " " && !address.envelopeBox[2].toLowerCase().includes(country.name.toLowerCase())) {
        address.envelopeBox[2] = address.envelopeBox[2] + " " + country.name
      }
      line3Preview = address.envelopeBox[2]
    } */

    let pages = 0;
    if (this.props.draftsSelected) {
      this.props.draftsSelected.forEach(d => {
        pages = pages + d.pages
      })
    }

    let errors = this.state.errors
    if (this.props.ownerAddress === "SENDER" && !Validators.documentIdentification(address.identityCard).isValid) {
      errors.identityCard = localizer.ValidationFieldTextIdCard;
    } else if (this.props.ownerAddress !== "SENDER" && address.identityCard !== null && address.identityCard !== "" && !Validators.documentIdentification(address.identityCard).isValid) {
      errors.identityCard = localizer.ValidationFieldTextIdCard;
    } else {
      errors.identityCard = "";
    }
    
    this.setState({
      address: address,
      line1Preview: line1Preview,
      line2Preview: line2Preview,
      line3Preview: line3Preview,
      countrySelected: countrySelected,
      streetTypeSelected: streetTypeSelected,
      totalPages: pages,
      //isEditing: this.props.isEditing,
      errors: errors
    })
  }

  /* check if the box is valid to take its coordinates
   * It is defined but some of its coordinates are missing
   * Some of its coordinates are negative
   * The defined area is zero (a line, a point
  */
  validateBoxSelector = (Box) => {
    if (!Box.width || !Box.height || !Box.left || !Box.top) return false
    if (Box.width < 0 || Box.height < 0 || Box.left < 0 || Box.top < 0) return false
    if (Box.width === 0 || Box.height === 0 || (Box.left === Box.top)) return false
    
    return true
  }

  /**
   * When user change the country, countryISO and country selected from state must be refresh.  
   */
  handleCountriesSelect = (event, option) => {
    if (option !== null) {
      var countryIso = option.alpha2

      //var countrySelected = countries.find(country => country.alpha2 === countryIso)

      let line1Preview = this.state.line1Preview
      let line2Preview = this.state.line2Preview
      let line3Preview = this.state.line3Preview

      //let envelopeBox = this.state.address.envelopeBox

      var countrySelected = allCountries.find(country => country.alpha2 === countryIso.toLowerCase()) !== undefined
        ? allCountries.find(country => country.alpha2 === countryIso.toLowerCase())
        : allCountries.find(country => country.alpha2 === "es")
      
      let country = allCountries.find(item => item.alpha2 === countrySelected.alpha2);
     
      var postalCode = (this.state.address.postalCode !== null && this.state.address.postalCode !== undefined) ? this.state.address.postalCode.toString() : ""
      line3Preview = postalCode + " " + this.state.address.locality + " " + country.name
      /* envelopeBox = []
      envelopeBox.push(line1Preview)
      envelopeBox.push(line2Preview)
      envelopeBox.push(line3Preview)
 */
      this.setState(previousState => ({
        address: {
          ...previousState.address,
          //envelopeBox: envelopeBox,
          countryIso: countryIso
        },
        countrySelected: countrySelected,
        line1Preview: line1Preview,
        line2Preview: line2Preview,
        line3Preview: line3Preview
      }),
        () => {
          this.props.handleAddress(this.state.address, this.props.ownerAddress)
        }
      )
    }
  }

  /**
 * When user change the street type, streetType and street type selected from state must be refresh.  
 */
  handleStreetSelect = (event, option) => {
    if (option !== null) {
      var streetType = option.name

      var streetTypeSelected = streetTypes.find(st => st.name === streetType)

      let line1Preview = this.state.line1Preview
      let line2Preview = this.state.line2Preview
      let line3Preview = this.state.line3Preview

      //let envelopeBox = this.state.address.envelopeBox

      var streetNumber = (this.state.address.streetNumber !== null && this.state.address.streetNumber !== undefined) ? this.state.address.streetNumber.toString() : ""
      var streetTypeValue = (streetType !== null && streetType !== undefined) ? streetType.toString() : "";
      var streetComplements = (this.state.address.streetComplements !== null && this.state.address.streetComplements !== undefined) ? this.state.address.streetComplements.toString() : "";

      line2Preview = streetTypeValue + " " + this.state.address.streetName + " " + streetNumber + " " + streetComplements
      /* envelopeBox = []
      envelopeBox.push(line1Preview)
      envelopeBox.push(line2Preview)
      envelopeBox.push(line3Preview) */
      this.setState(previousState => ({
        address: {
          ...previousState.address,
          //envelopeBox: envelopeBox,
          streetType: streetType
        },
        streetTypeSelected: streetTypeSelected,
        line1Preview: line1Preview,
        line2Preview: line2Preview,
        line3Preview: line3Preview
      }),
        () => {
          this.props.handleAddress(this.state.address, this.props.ownerAddress)
        }
      )
    }
  }

  /**
   * Handle onChange event to update the state for inputs. 
   * We build the data in "3 lines" format in the setState callback
   */
  onInputchange = (event) => {
    
    this.setState({ isEditing: true })
    var inputName = event.target.name
    var inputValue = event.target.value

    if (inputName.startsWith("line")) {
      
      this.setState({ [inputName]: inputValue }, () => {
        let line1Preview = this.state.line1Preview
        let line2Preview = this.state.line2Preview
        let line3Preview = this.state.line3Preview

        /* let envelopeBox = []
        envelopeBox.push(line1Preview)
        envelopeBox.push(line2Preview)
        envelopeBox.push(line3Preview) */

        let blockAddressForm = line1Preview !== "" || line2Preview !== "" || line3Preview !== ""
        
        this.setState(previousState => ({
          address: {
            ...previousState.address,
            //envelopeBox: envelopeBox
          },
          blockAddressForm: blockAddressForm
        }), () => { this.props.handleAddress(this.state.address, this.props.ownerAddress) })
      })
    }
    else {
      this.setState(previousState => ({
        address: {
          ...previousState.address,
          [inputName]: inputValue
        },
      }),
        () => {
          this.handleValidate(inputName)

          let line1Preview = this.state.line1Preview
          let line2Preview = this.state.line2Preview
          let line3Preview = this.state.line3Preview

          //let envelopeBox = this.state.address.envelopeBox

          if (!this.state.blockAddressForm) {
            if (inputName === "who") {
              line1Preview = this.state.address.who
            }
  
            if ((inputName === "streetType") || (inputName === "streetName") || (inputName === "streetNumber") || (inputName === "streetComplements")) {
              var streetNumber = (this.state.address.streetNumber !== null && this.state.address.streetNumber !== undefined) ? this.state.address.streetNumber.toString() : ""
              var streetType = (this.state.address.streetType !== null && this.state.address.streetType !== undefined) ? this.state.address.streetType.toString() : "";
              var streetComplements = (this.state.address.streetComplements !== null && this.state.address.streetComplements !== undefined) ? this.state.address.streetComplements.toString() : "";

              line2Preview = streetType + " " + this.state.address.streetName + " " + streetNumber + " " + streetComplements
            }
  
            if ((inputName === "locality") || (inputName === "postalCode")) {
              var countrySelected = allCountries.find(country => country.alpha2 === this.state.address.countryIso.toLowerCase()) !== undefined
                ? allCountries.find(country => country.alpha2 === this.state.address.countryIso.toLowerCase())
                : allCountries.find(country => country.alpha2 === "es")
              let country = allCountries.find(item => item.alpha2 === countrySelected.alpha2);
     
              var postalCode = (this.state.address.postalCode !== null && this.state.address.postalCode !== undefined) ? this.state.address.postalCode.toString() : ""
              line3Preview = postalCode + " " + this.state.address.locality + " " + country.name
            }
          
            /* envelopeBox = []
            envelopeBox.push(line1Preview)
            envelopeBox.push(line2Preview)
            envelopeBox.push(line3Preview) */
          }

          this.setState(previousState => ({
            address: {
              ...previousState.address,
              //envelopeBox: envelopeBox
            },
            line1Preview: line1Preview,
            line2Preview: line2Preview,
            line3Preview: line3Preview
          }),
            () => {
              this.props.handleAddress(this.state.address, this.props.ownerAddress)
            })
        }
      );
    }
  }

  // Validate input data
  handleValidate = (inputName) => {
    let address = this.state.address
    let errors = this.state.errors

    switch (inputName) {
      case 'who':
        if (!address.who) {
          errors.who = localizer.ValidationFieldAddressee
        } else {
          errors.who = ""
        }
        break;
      case 'identityCard':
        if (address.identityCard) {
          if (!Validators.documentIdentification(address.identityCard).isValid) {
            errors.identityCard = localizer.ValidationFieldTextIdCard
          } else {
            errors.identityCard = ""
          }
        }
        break
      case 'locality':
        if (!address.locality) {
          errors.locality = localizer.ValidationFieldTextLocality
        } else {
          errors.locality = ""
        }
        break;
      case 'postalCode':
        if (!address.postalCode) {
          errors.postalCode = localizer.ValidationFieldTextPostalCode
        } else {
          errors.postalCode = ""
        }
        break;
      case 'streetName':
        if (!address.streetName) {
          errors.streetName = localizer.ValidationFieldTextDestinatioAddress
        } else {
          errors.streetName = ""
        }
        break;
    
      default:
        break;
    }
    this.setState({ errors: errors })
  }
  

  /* Fills envelope box and address by a postal address received */
  selectPostalAddress = (postalAddress) => {

    /*let country = countries.find(item => item.alpha2 === postalAddress.countryIso.toLowerCase());
    
    var line1Preview = postalAddress.who
    var line2Preview = postalAddress.streetType + " " + postalAddress.streetName + " " + postalAddress.streetNumber + " " + postalAddress.streetComplements
    var line3Preview = postalAddress.postalCode + " " + postalAddress.locality + " " + country.name
      
     postalAddress.envelopeBox = []
    postalAddress.envelopeBox.push(line1Preview)
    postalAddress.envelopeBox.push(line2Preview)
    postalAddress.envelopeBox.push(line3Preview) */

    //this.setState({ address: postalAddress, line1Preview: line1Preview, line2Preview: line2Preview, line3Preview: line3Preview })
    this.props.handleAddress(postalAddress, this.props.ownerAddress)

    this.doCloseAddressModal()
    this.doCloseOcrAddressModal()
  }

  doOpenAddressModal = () => {
    this.setState({ openAddressModal: true })
  }

  doCloseAddressModal = () => {
    this.setState({ openAddressModal: false })
  }

  doOpenMultishipmentModal = () => {
    //check if sender has been entered and if it has drafts
    if (this.props.draftsSelected.length === 0) {
      this.setState({ draftError: localizer.BoxSelectorNoDocument })
      return
    }
    
    if (this.props.alertSenderEmpty) {
      this.setState({ errorSenderEmpty: localizer.AlertSenderEmpty })
      return
    }
    
    this.setState({ openMultishipmentModal: true })
  }

  doCloseMutishipmentModal = (event) => {
    if (event && event.type !== "click") return
    this.setState({ openMultishipmentModal: false })
  }

  /* Request for Base64 of the first draft page when Detect Address Modal opens */
  doOpenOcrAddressModal = () => {

    if (this.props.draftsSelected.length === 0) return this.setState({ draftError: localizer.BoxSelectorNoDocument })
    
    let pagenumber = this.props.shipments && this.props.shipments.length > 0 && this.props.shipments[0].pages.length > 0 ?
      this.props.shipments[0].pages[0].pageFirst : 1
    
    OutboxCli.GetDraftPageImage(this.props.draftsSelected[0].draftId,
      pagenumber,
      0,
      0,
      100,
      100
    ).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ draftError: response.substring(response.indexOf(' ')) })
      } else {
        this.setState({ document: response })
      }
      this.setState({ openOcrAddressModal: true })
    })
    
  }

  doCloseOcrAddressModal = () => {
    this.setState({ openOcrAddressModal: false })
  }

  /* Sets coordinates selected when user drag an address in the document */
  handleAddressBoxChange = (l, t, w, h) => {
    this.setState({
      addressLeft: l,
      addressTop: t,
      addressWidth: w,
      addressHeight: h,
    })
  }

  /* After an address is detected, ORC will give some postal address proposal */
  doDetectAddress = () => {
    if (this.props.draftsSelected.length === 0) return this.setState({ draftError: localizer.BoxSelectorNoDocument })
    
    this.setState({ isLoading: true })
    
    OutboxCli.DetectAddressesInPage(this.props.draftsSelected[0].draftId,
      1,
      this.state.addressLeft,
      this.state.addressTop,
      this.state.addressWidth,
      this.state.addressHeight,
      this.props.productSelected ? this.props.productSelected.productCode : null
    ).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ detectAddressError: response.substring(response.indexOf(' ')) })
      } else {
        if (response.length > 0) {
          this.selectPostalAddress(response[0])
        } else {
          this.setState({ detectAddressError: localizer.AddressNotDetected })
        }
      }
      this.doCloseOcrAddressModal()
      this.setState({ isLoading: false })
    })
  }

  doAcceptProposalAddress = () => {
    this.setState({ isEditing: false })
    this.props.doAcceptProposalAddress(this.state.address)
  }

  doDiscardProposalAddress = () => {
    this.setState({ isEditing: false })
    this.props.doDiscardProposalAddress()
  }

  handleMultishipment = (shipments, isValidedProposalAddress) => {
    this.doCloseMutishipmentModal()
    this.props.handleMultishipment(shipments, isValidedProposalAddress)
  }

  handleonClose = () => {
    this.setState({ detectAddressError: null, draftError: null, errorSenderEmpty: null })
  }

  onCloseFormatsModal = () => { this.setState({ openFormatsModal: false })}
  
  render() {

    const isMultiAndNotInitial = this.props.multishipment && this.props.multishipment !== "INITIAL"
    const disabledOCR = this.props.billable && this.props.billable.billableOptions && this.props.billable.billableOptions.disabledOCR ? this.props.billable.billableOptions.disabledOCR : false
    const countries_list = this.props.productSelected && this.props.productSelected.scope === "INTERNATIONAL" ? allCountries : allCountries.filter(c => c.alpha2.toUpperCase() === "ES" || c.alpha2.toUpperCase() === "PT")

    return (
      <React.Fragment>
        <Grid container direction="row" justify="center" alignItems="center" className={isMultiAndNotInitial ? "disabled" : ""} style={{ padding: 10, marginTop: 10, border: "solid 2px gray", backgroundColor: this.props.ownerAddress === "SENDER" ? "rgb(218, 218, 218, 0.2)" : "" }}>
          <Grid container item md={12}>
            {this.props.multishipment === false &&
              <Grid container item md={12}>
                <Grid item md={6}>
                  <Typography className="typography-generic address-title color-txt-primary" style={{ fontSize: "20px !important" }}>
                    {this.props.ownerAddress === "SENDER" ? <i className="fa-solid fa-address-card color-txt-primary mt-10 mr-10 font-size-20"></i> : <i className="fa-regular fa-address-card color-txt-primary mt-10 mr-10 font-size-20"></i>}
                    {this.props.ownerAddress === "SENDER" ? localizer.AddressSelectorSenderText : localizer.AddressSelectorRecipientText}
                  </Typography>
                </Grid>
                <Grid item md={6} className="text-align-right">
                  {this.props.ownerAddress === "SENDER" &&
                    <Button className="button-generic secondary-main-action mt-10" variant="contained" onClick={this.doOpenAddressModal} >
                      {localizer.SelectAddress}
                    </Button>

                  }
                </Grid>
                
                <Grid item md={12} ><hr className="hr-custom" /></Grid>


                {this.props.ownerAddress === "RECIPIENT" && !disabledOCR &&
                  <Grid item md={12} className="mt-10" >
                    
                    <Paper elevation={2} className="mr-15 p-10">
                      <Grid container item md={12} direction="row" justify="flex-end">
                        <Typography className="typography-generic color-txt-primary mr-10">{localizer.OCAaddressDetection}</Typography>
                      
                        <Button className="button-generic secondary-main-action" variant="contained" startIcon={<i className="fa-solid fa-crop-simple"></i>} onClick={this.doOpenOcrAddressModal} >
                          {localizer.DetectAddress}
                        </Button>
                        <Button disabled={this.props.notNewShipment} className="button-generic secondary-main-action ml-10" variant="contained" startIcon={<i className="fa-solid fa-crop-simple"></i>} onClick={this.doOpenMultishipmentModal} >
                          {localizer.Multishipment}
                        </Button>
                      </Grid>
                    </Paper>
                  </Grid>
                }
              </Grid>
            }
          </Grid>

          <Grid container item md={7} spacing={2} >
            {/* addressee field */}
            <Grid container item md={12} spacing={2} className="mt-10">
              <Grid item md={12}>
                <TextFieldStyled id="textfield-who"
                  label={<Typography className="typography-generic">{this.props.ownerAddress === "SENDER" ? localizer.AddresseeNameSender : localizer.AddresseeNameRecipient}</Typography>}
                  name="who"
                  value={this.state.address.who}
                  onChange={this.onInputchange}
                  variant="outlined" fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    inputProps: { maxLength: 100 }
                  }}
                />
                <span style={{ color: "red" }}>{this.state.errors.who}</span>
              </Grid>
            </Grid>
            

            <Grid container item md={12} spacing={2}>
            
              {/* Full Address field */}
              <Grid item md={12}>
                <TextFieldStyled id="textfield-streetname"
                  label={<Typography className="typography-generic">{localizer.FullAddress}</Typography>}
                  name="streetName" value={this.state.address.streetName}
                  onChange={this.onInputchange}
                  variant="outlined" fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    inputProps: { maxLength: 100 }
                  }}
                />
                <span style={{ color: "red" }}>{this.state.errors.streetName}</span>
              </Grid>
            </Grid>

            <Grid container item md={12} spacing={2}>
              {/* Postal code field */}
              <Grid item md={6}>
                <TextFieldStyled id="textfield-postalcode"
                  label={<Typography className="typography-generic">{localizer.PostalCode}</Typography>}
                  name="postalCode"
                  value={this.state.address.postalCode}
                  onChange={this.onInputchange}
                  variant="outlined" fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    inputProps: { maxLength: 100 }
                  }}
                />
                <span style={{ color: "red" }}>{this.state.errors.postalCode}</span>
              </Grid>
              {/* Localitiy field */}
              <Grid item md={6}>
                <TextFieldStyled id="textfield-locality"
                  label={<Typography className="typography-generic">{localizer.Locality}</Typography>}
                  name="locality"
                  value={this.state.address.locality}
                  onChange={this.onInputchange}
                  variant="outlined" fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    inputProps: { maxLength: 100 }
                  }}
                />
                <span style={{ color: "red" }}>{this.state.errors.locality}</span>
              </Grid>
            </Grid>
              
            <Grid container item md={12} spacing={2}>
              {/* ISO country field */}
              <Grid item md={6}>
                <AutocompleteStyled
                  id="countries"
                  options={countries_list}
                  classes={{ input: 'typography-generic', option: 'typography-generic' }}
                  getOptionLabel={(option) => (option.name ? option.name : '')}
                  getOptionSelected={(option, value) => option.value === value.value}
                  renderInput={(params) => <TextField {...params} label={<Typography className="typography-generic">{localizer.Country}</Typography>} variant="outlined" />}
                  onChange={this.handleCountriesSelect}
                  value={this.state.countrySelected}
                  fullWidth
                />
              </Grid>
             {/*  Identity card field */}
               <Grid item md={6}>
                <TooltipStyled className="tooltip-custom-w" placement="top-end" title={
                  <React.Fragment>
                    <Typography className="typography-generic small"><b>NIF:</b> <span style={{ opacity: "0.6" }}>07806892W</span></Typography>
                    <Typography className="typography-generic small"><b>NIE:</b> <span style={{ opacity: "0.6" }}>X7120951J</span></Typography>
                    <Typography className="typography-generic small"><b>CIF:</b> <span style={{ opacity: "0.6" }}>R9178125B</span></Typography>
                  </React.Fragment>
                }>
                  <Badge
                    badgeContent={<i className="fa-solid fa-info"></i>}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    className="badge-info"
                    style={{ width: "100%" }}>
                    <TextFieldStyled id="textfield-identifycard" label={<Typography className="typography-generic">{localizer.AddresseDocumentId}</Typography>}
                      name="identityCard"
                      value={this.state.address.identityCard ? this.state.address.identityCard : ""}
                      onChange={this.onInputchange}
                      variant="outlined" fullWidth
                      InputProps={{
                        classes: {
                          input: "typography-generic"
                        },
                        inputProps: { maxLength: 100 }
                      }}
                    />
                  </Badge>
                </TooltipStyled>
                <span style={{ color: "red" }}>{this.state.errors.identityCard}</span>
              </Grid>
            </Grid>
              
          </Grid>

          <Grid container item md={5}>
            <Grid container item md={12} spacing={2} style={{ border: 'solid 2px var(--custom-primary-color)' }}>
              <Grid container item md={12} spacing={2}>
                <Grid container item md={12} >
                  <Grid item md={12} ></Grid>
                  <i className="fa-solid fa-envelope color-txt-primary mt-10"></i>
                  <Typography className="typography-generic color-txt-primary">{localizer.PrintView}</Typography>
                  <Grid item md={12} >
                    <hr className="hr-custom" /></Grid>
                </Grid>
              </Grid>
              <Grid container item md={12} spacing={2}>
                <Grid item md={12}>
                  <TextFieldStyled id="line1-preview" name="line1Preview" value={this.state.line1Preview} onChange={this.onInputchange} fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                    disabled={true}
                  />
                </Grid>
              </Grid>
              <Grid container item md={12} spacing={2}>
                <Grid item md={12}>
                  <TextFieldStyled id="line2-preview" name="line2Preview" value={this.state.line2Preview} onChange={this.onInputchange} fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                    disabled={true}
                  />
                </Grid>
              </Grid>
              <Grid container item md={12} spacing={2}>
                <Grid item md={12}>
                  <TextFieldStyled id="line3-preview" name="line3Preview" value={this.state.line3Preview} onChange={this.onInputchange} fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic"
                      }
                    }}
                    disabled={true}
                  />
                </Grid>
              </Grid>
            </Grid>
            {this.props.multishipment && this.props.multishipment === "INITIAL" ?
              <Grid item md={12} className="mt-10">
                <Button className="button-generic ocr-multi-shipment-button-primary" variant="contained" name="setasadddress" disabled={!this.state.isEditing} onClick={this.doAcceptProposalAddress}>{localizer.MultishipmentApply}</Button>
                <Button className="button-generic ocr-multi-shipment-button-primary" variant="contained" name="discardchanges" disabled={!this.state.isEditing} onClick={this.doDiscardProposalAddress}>{localizer.MultishipmentDiscard}</Button>
              </Grid>
              : this.props.multishipment && this.props.multishipment !== "INITIAL" ?
                <Grid item md={12} className="mt-10">
                  <Button className="button-generic ocr-multi-shipment-button-primary" variant="contained" name="setasadddress" onClick={this.doAcceptProposalAddress} disabled>{localizer.MultishipmentApply}</Button>
                  <Button className="button-generic ocr-multi-shipment-button-primary" variant="contained" name="discardchanges" onClick={this.doDiscardProposalAddress} disabled>{localizer.MultishipmentDiscard}</Button>
                </Grid>
                :
                ""
            }
          </Grid>

        </Grid>
        
        {/* Select sender address modal */}
        <Dialog
          open={this.state.openAddressModal}
          onClose={this.doCloseAddressModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"lg"}
        >
          <DialogContent dividers={true}>
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseAddressModal}></i>
            <PostalAddressLayout selectPostalAddress={this.selectPostalAddress}></PostalAddressLayout>
          </DialogContent>
        </Dialog>

        {/*  ORC Address Modal  */}
        <Dialog
          open={this.state.openOcrAddressModal}
          onClose={this.doCloseOcrAddressModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"lg"}
        >
          <DialogContent dividers={true} className="p-0">
            
            <Grid container item md={12}>
              <Grid container item md={4} className="bg-secondary" style={{ display: "block", padding: "40px" }}>
                <Grid item md={12}>
                  <Typography className="typography-generic">{localizer.OcrSingleShipment}</Typography>
                </Grid>
                <Grid item md={12}>
                  <ol>
                    <li className="typography-generic">{localizer.BoxSelectorStepOneIndividual}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepTwo}</li>
                    <li className="typography-generic">{localizer.BoxSelectorStepThreeIndividual}</li>
                  </ol>
                </Grid>
              </Grid>
              <Grid container item md={8}>
                <Grid container item md={12} direction="row" justify="center" alignItems="center">
                  <Grid item md={12} className="ocr-single-shipment-button">
                    <Typography className="typography-generic bigweight ocr-title-button-modal">{localizer.OcrSingleShipment}<i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseOcrAddressModal}></i></Typography>
                  </Grid>
                  <Grid item md={12} className="ml-20 mr-20">
                    <Alert severity="info" className="mt-5">
                      <Typography className="typography-generic p-0">
                        {localizer.OcrProcessTitle}
                        <a className="cursor-pointer font-weight-bold" onClick={() => { this.setState({ openFormatsModal: true }) }}>{localizer.ClickHere}</a>
                      </Typography>
                    </Alert>
                    <Alert severity="warning" className="mt-5">
                      <AlertTitle>
                        <Typography className="typography-generic font-weight-bold p-0">{localizer.Warning}:</Typography>
                      </AlertTitle>
                      <Typography className="typography-generic p-0">
                        {localizer.formatString(localizer.MultiShipmentWarning, "1")}</Typography>
                    </Alert>
                  </Grid>
                </Grid>

                <Grid container item md={12} direction="row" spacing={4} justify="center" alignItems="center" className="mt-20 mb-20">
                  {this.state.document &&
                    <BoxSelector
                      imageSrc={"data:image/png;base64, " + this.state.document}
                      canvasWidth={750}
                      canvasHeight={900}
                      left={this.state.addressLeft}
                      top={this.state.addressTop}
                      width={this.state.addressWidth}
                      height={this.state.addressHeight}
                      onChanged={(l, t, w, h) => this.handleAddressBoxChange(l, t, w, h)}
                    />
                  }
                </Grid>
                <Grid container item md={12} direction="row" justify="flex-end" alignItems="flex-end" className="pb-20 pr-20">
                  <Button className="button-generic dialog-primary" variant="contained" onClick={this.doDetectAddress}>{localizer.Accept}</Button>
                </Grid>
              </Grid>
            </Grid>
          
          </DialogContent>
        </Dialog>

        {/* Multishipment modal */}
        <Dialog
          open={this.state.openMultishipmentModal}
          onClose={this.doCloseMutishipmentModal}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          fullWidth
          maxWidth={"lg"}
        >
          <DialogContent dividers={true} >
            <i className="fa-solid fa-circle-xmark closeoutlinedicon-custom" onClick={this.doCloseMutishipmentModal}></i>
            <MultiShipmentLayout
              documentsid={this.props.draftsSelected && this.props.draftsSelected.map(d => d.draftId)}
              totalpages={this.state.totalPages}
              handleMultishipment={this.handleMultishipment}
              shipments={this.props.shipments}
              billable={this.props.billable}
              productSelected={this.props.productSelected}>
            </MultiShipmentLayout>
          </DialogContent>
        </Dialog>

        {/* Address formats modal */}
        <AddressFormatsModal openModal={this.state.openFormatsModal  !== undefined ? this.state.openFormatsModal : false} handleCloseModal={this.onCloseFormatsModal} />

        {/* Detect address error. */}
        <SnackbarCustom message={this.state.detectAddressError} severity="info" handleonClose={this.handleonClose} />
        <SnackbarCustom message={this.state.draftError} severity="error" handleonClose={this.handleonClose} />
        <SnackbarCustom message={this.state.errorSenderEmpty} severity="error" handleonClose={this.handleonClose} />

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
        
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/shipments/sections/address/AddressSelector.js